export const strings = {
    name: "LLynvees German Shepherd Dogs",
    about: "About ourselves",
    message_1: "For over 20 years, Julian and Anita have been running the Llynfi Vale Kennels. As responsible breeders we are always trying to increase the quality of the Breed. All our females are hip and elbow tested and we use fully tested stud dogs at Rockforce", 
    message_2: "Meet the girls...",
    message_3: "We're fortunate enough to own 16 acres of open fields, and here's Prudie galloping about!",
    rockfort_url: "www.rockforcegsd.co.uk",
    testimonials: "Feedback",
};